const Faq = (props) => {
  return (
    <section className="w-full flex justify-center pt-16 pb-80 bg-[url(../../assets/images/faq-bg.png)] bg-cover bg-top -mt-60">
      <div
        id={props.currentLang === "eng" ? "faq" : "sss"}
        className="w-4/5 max-w-screen-xl space-y-14 pt-32"
      >
        <div data-aos="fade-up" className="flex justify-center">
          <h4 className="text-4xl sm:text-5xl md:text-7xl font-bold text-green-custom text-center">
            {props.currentLang === "eng"
              ? "FREQUENTLY ASKED QUESTIONS"
              : "SIKÇA SORULAN SORULAR"}
          </h4>
        </div>
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0">
          <div
            data-aos={window.innerWidth >= 768 ? "fade-right" : "fade-up"}
            className="flex flex-col w-full md:w-1/2 space-y-4 px-0 md:px-7"
          >
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "Who can apply to BizzTrip?"
                  : "BizzTrip'e kimler başvurabilir?"}
              </h4>
              <p className="text-black font-normal text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "All university student and new graduates can apply to BizzTrip."
                  : "BizzTrip'e tüm üniversite öğrencileri ve yeni mezunlar başvurabilir."}
              </p>
            </div>
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "Will the event be held in English?"
                  : "Etkinlik İngilizce mi yapılacak?"}
              </h4>
              <p className="text-black font-normal text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "No, BizzTrip will be held in Turkish. However, translation support will be provided during the event."
                  : "Hayır, etkinlik Türkçe gerçekleştirilecektir. Ancak etkinlik süresince çeviri desteği sağlanacaktır."}
              </p>
            </div>
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "What is the date of BizzTrip?"
                  : "Bizztrip'in tarihi nedir?"}
              </h4>
              <p className="text-black font-normal text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "BizzTrip will be at January 26, 2023."
                  : "Etkinlik 26 Ocak 2023 tarihinde yapılacaktır."}
              </p>
            </div>
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "How will BizzTrip be held?"
                  : "BizzTrip nasıl yapılacak?"}
              </h4>
              <p className="text-black font-normal text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "BizzTrip will be held online."
                  : "Etkinlik online olarak gerçekleştirilecektir."}
              </p>
            </div>
          </div>
          <div
            data-aos={window.innerWidth >= 768 ? "fade-left" : "fade-up"}
            className="flex flex-col w-full md:w-1/2 space-y-4 px-0 md:px-7"
          >
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold  text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? " Where can I watch BizzTrip?"
                  : "BizzTrip’i nerden izleyebilirim?"}
              </h4>
              <p className="text-black font-normal  text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "On January 26th, the website you are on will switch to live broadcast mode. You can watch the live broadcast by entering the necessary information."
                  : "26 Ocak'ta bulunduğun site canlı yayın moduna geçecek. Gerekli bilgileri girerek canlı yayını izleyebilirsin."}
              </p>
            </div>
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold  text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? " How can I ask my questions to the speakers?"
                  : "Konuşmacılara nasıl soru sorabilirim?"}
              </h4>
              <p className="text-black font-normal  text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? "You can ask any question while registering for BizzTrip or during the live broadcast."
                  : "Canlı yayın sırasında aklına takılan her soruyu sorabilirsin."}
              </p>
            </div>
            <div className="flex flex-col">
              <h4 className="text-green-custom font-bold text-lg lg:text-2xl">
                {props.currentLang === "eng"
                  ? " I have another question, how can I reach you?"
                  : "Başka bir sorum var, size nasıl ulaşabilirim?"}
              </h4>
              {props.currentLang === "eng" ? (
                <p className="text-black font-normal text-lg lg:text-2xl">
                  You can direct your questions to{" "}
                  <a
                    className="hover:text-green-800"
                    href="https://www.instagram.com/unilevercareerstr/"
                  >
                    @unilevercareerstr
                  </a>{" "}
                  account on Instagram.
                </p>
              ) : (
                <p className="text-black font-normal text-lg lg:text-2xl">
                  Instagram’da{" "}
                  <a
                    className="hover:text-green-800"
                    href="https://www.instagram.com/unilevercareerstr/"
                  >
                    @unilevercareerstr
                  </a>{" "}
                  hesabımızı takip ederek bize sorularını iletebilirsin.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
